import {
  Box,
  Grid,
  Button,
  Checkbox,
  CircularProgress,
  Backdrop,
  Typography,
} from "@mui/material";
import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { DataGridPro } from "@mui/x-data-grid-pro";
import { centralAdminUrls } from "../centralAdminUtils";
import axios from "axios";
import { SaveScenarioRoleMapping, setState } from "../centralAdminSlice";
import SharedComponent from "../SharedComponent";

export default function NormalModification({normalRows, setNormalRows}) {
  const dispatch = useDispatch();
  const centralAdmin = useSelector((state) => state.centralAdmin);
  const columns = [
    { field: "criticalityName", 
      headerName: "Scenario Criticality", 
      flex: 1,
      renderCell:(params)=>(
        <Typography sx={{fontWeight:"bold"}}>{params.value}</Typography>
       ), 
     },
    {
      field: "key2",
      headerName: "Country Analyst",
      flex: 1,
      align: "center",
      headerAlign: "center",
      renderCell: (params) => {
        return <TableCheckBox2 params={params} />;
      },
    },
    {
      field: "key4",
      headerName: "Country Approver",
      flex: 1,
      align: "center",
      headerAlign: "center",
      renderCell: (params) => {
        return <TableCheckBox4 params={params} />;
      },
    },
    {
      field: "key3",
      headerName: "HQ Analyst",
      align: "center",
      headerAlign: "center",
      renderCell: (params) => {
        return <TableCheckBox3 params={params} />;
      },
      flex: 1,
    },
    {
      field: "key5",
      headerName: "HQ Approver",
      flex: 1,
      align: "center",
      headerAlign: "center",
      renderCell: (params) => {
        return <TableCheckBox5 params={params} />;
      },
    },
    {
      field: "key1",
      headerName: "Administrator",
      flex: 1,
      align: "center",
      headerAlign: "center",
      renderCell: (params) => {
        return <TableCheckBox1 params={params} />;
      },
    },
  ];

  const [isLoading, setIsLoading] = useState(false);

  let baseUrl = centralAdminUrls.getScenarioCriticality;
  const autherization = localStorage.getItem("data");
  const data = JSON.parse(autherization);
  const token = data.token;

  //const [normalRows, setNormalRows] = useState([]);

  // useEffect(() => {
  //   //setIsLoading(true);
  //   axios
  //     .get(baseUrl, {
  //       headers: {
  //         Authorization: "Bearer " + token,
  //       },
  //     })
  //     .then((response) => {
  //       const nrmlData = response.data.nrmlModificationLst;

  //       const nrmlResult = nrmlData.map(
  //         ({ criticalityId, criticalityName, permissionValues }) =>
  //           permissionValues.reduce(
  //             (acc, { key, value }) => {
  //               acc[`key${key}`] = value;
  //               return acc;
  //             },
  //             { criticalityId, criticalityName }
  //           )
  //       );

  //       setNormalRows(nrmlResult);
  //       setIsLoading(false);
  //     });
  // }, [baseUrl]);

  function SaveNormalModification() {
    const quotaType = "N";

    const transformedArray = normalRows.map((obj) => {
      const { criticalityId, criticalityName, ...permissions } = obj;
      const permissionList = Object.entries(permissions).map(
        ([key, value]) => ({ key, value })
      );

      const permissionValues = permissionList.map((list) =>
        list.key.includes("key")
          ? { ...list, key: list.key.replace("key", "") }
          : list
      );

      return { criticalityId, criticalityName, permissionValues };
    });

    let obj = {
      quotaType: quotaType,
      transformedArray,
    };

    setIsLoading(true);
    dispatch(SaveScenarioRoleMapping(obj)).finally(()=>{
      setIsLoading(false);
    });
  }

  return (
    <>
      <div style={{ width: "100%" }}>
        <div style={{fontWeight:'bold',color:"#AD2A1C",marginBottom:2}}>Normal Modification</div>
        <Backdrop
          sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
          open={isLoading}
        >
          <CircularProgress />
        </Backdrop>
        <SharedComponent />
        <DataGridPro
          disableColumnMenu
          rows={normalRows || []}
          columns={columns}
          getRowId={(normalRows) => normalRows?.criticalityId}
          disableRowSelectionOnClick
          sx={{
            "& .MuiDataGrid-footerContainer": {
              display: "none !important",
            },
          }}
        />
      </div>
      <Box justifyContent="right" display="flex" mt={2}>
        <Button
          variant="contained"
          size="large"
          sx={{
            bgcolor: "darkred.light",
            color: "white.main",
            textTransform: "none",
            fontWeight: "bold",
            "&:hover": {
              bgcolor: "darkred.main",
              color: "white.main",
            },
          }}
          onClick={SaveNormalModification}
        >
          Save
        </Button>
      </Box>
    </>
  );

  function TableCheckBox1(params) {
    const [checked, setChecked] = useState(params.params.row.key1);
    const criticalityId = params.params.row.criticalityId;
    const handleChange = (event) => {
      const updatedNormalRows = normalRows.map((obj) =>
        obj.criticalityId === criticalityId
          ? Object.assign(obj, { key1: event.target.checked })
          : obj
      );

      setNormalRows(updatedNormalRows);
      setChecked(event.target.checked);
    };
    return (
      <Checkbox
        checked={checked}
        onChange={handleChange}
        inputPros={{ "aria-label": "primary checkbox" }}
      />
    );
  }

  function TableCheckBox2(params) {
    const [checked, setChecked] = useState(params.params.row.key2);
    const criticalityId = params.params.row.criticalityId;
    const handleChange = (event) => {
      const updatedNormalRows = normalRows.map((obj) =>
        obj.criticalityId === criticalityId
          ? Object.assign(obj, { key2: event.target.checked })
          : obj
      );

      setNormalRows(updatedNormalRows);
      setChecked(event.target.checked);
    };
    return (
      <Checkbox
        checked={checked}
        onChange={handleChange}
        inputPros={{ "aria-label": "primary checkbox" }}
      />
    );
  }

  function TableCheckBox3(params) {
    const [checked, setChecked] = useState(params.params.row.key3);
    const criticalityId = params.params.row.criticalityId;
    const handleChange = (event) => {
      const updatedNormalRows = normalRows.map((obj) =>
        obj.criticalityId === criticalityId
          ? Object.assign(obj, { key3: event.target.checked })
          : obj
      );

      setNormalRows(updatedNormalRows);
      setChecked(event.target.checked);
    };
    return (
      <Checkbox
        checked={checked}
        onChange={handleChange}
        inputPros={{ "aria-label": "primary checkbox" }}
      />
    );
  }

  function TableCheckBox4(params) {
    const [checked, setChecked] = useState(params.params.row.key4);
    const criticalityId = params.params.row.criticalityId;
    const handleChange = (event) => {
      const updatedNormalRows = normalRows.map((obj) =>
        obj.criticalityId === criticalityId
          ? Object.assign(obj, { key4: event.target.checked })
          : obj
      );

      setNormalRows(updatedNormalRows);
      setChecked(event.target.checked);
    };
    return (
      <Checkbox
        checked={checked}
        onChange={handleChange}
        inputPros={{ "aria-label": "primary checkbox" }}
      />
    );
  }

  function TableCheckBox5(params) {
    const [checked, setChecked] = useState(params.params.row.key5);
    const criticalityId = params.params.row.criticalityId;
    const handleChange = (event) => {
      const updatedNormalRows = normalRows.map((obj) =>
        obj.criticalityId === criticalityId
          ? Object.assign(obj, { key5: event.target.checked })
          : obj
      );

      setNormalRows(updatedNormalRows);
      setChecked(event.target.checked);
    };
    return (
      <Checkbox
        checked={checked}
        onChange={handleChange}
        inputPros={{ "aria-label": "primary checkbox" }}
      />
    );
  }

  function generateRandom() {
    var length = 8,
      charset =
        "abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789",
      retVal = "";
    for (var i = 0, n = charset.length; i < length; ++i) {
      retVal += charset.charAt(Math.floor(Math.random() * n));
    }
    return retVal;
  }
}
